import React from 'react';
import styled from 'styled-components';
import PageTitle from '../components/PageTitle';
import '../components/Layout/layout.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Hero from '../components/Hero';
import Layout from '../components/Layout';
import Link from '../components/Link';
import SidebarMenu from '../components/Layout/Navigation/SidebarMenu';

const IndexPage = () => {
  return (
    <Layout upper={<Hero />}>
      <div className="row">
        <div className="col-sm-4 col-lg-3 my-4">
          <SidebarMenu />
        </div>

        <div className="col-sm-8 col-lg-9">
          <PageTitle name="Public Reports" site="OIRA" />
          <div>
            <p>
              In accordance with its mission, the Office of Institutional Research and Assessment provides various institutional information to external reporting groups. These reports are made avaiable to the public.
            </p>
            <p>
              OIRA offers reports on Advising Surveys, Student Enrollment, Minority Participation, and Recreation Center data.
            </p>

            {/* Cards Section */}
            <div className="row">
              {[
                {
                  title: 'Advising Survey',
                  description: 'This survey assesses student perceptions regarding the advising process and utilization of advising tools at The University of Alabama. Authorized users can access additional Advising Survey results for their college/school through a log in option.',
                  path: '/advisingSurvey/',
                  type: 'HTML',
                  external: false,
                },
                {
                  title: 'Common Data Set',
                  description: 'The Common Data Set (CDS) initiative is a collaborative effort among data providers in the higher education community and publishers as represented by the College Board, Peterson\'s, and U.S. News & World Report. The combined goal of this collaboration is to improve the quality and accuracy of information provided to all involved in a student\'s transition into higher education, as well as to reduce the reporting burden on data providers.',
                  path: '/commonDataSet/',
                  type: 'PDF',
                  external: false,
                },
                {
                  title: 'Student Enrollment',
                  description: 'Overview of enrollment data for each Fall term; includes tabulations by student status, race/ethnicity, college, age, sex, state of origin, and transfer status.',
                  path: '/enrollmentAtAGlance/',
                  type: 'PDF, PowerBI',
                  external: false,
                },
                // {
                //   title: 'Minority Participation',
                //   description: 'This report provides enrollment, degrees awarded, and faculty information for various university peer group comparison.',
                //   path: '/minorityParticipation/',
                //   type: 'PowerBI',
                //   external: false,
                // },
                {
                  title: 'Recreation Center Usage',
                  description: 'Utilization metrics for campus recreation facilities, at the request of the University Recreation Center.',
                  path: '/universityRecreation/',
                  type: 'PowerBI',
                  external: false,
                },
                {
                  title: 'Higher Education Act',
                  description: 'Reports that fulfill federal reporting obligations under the Higher Education Act, including metrics related to institutional affordability, student demographics, retention and graduation rates, financial aid distribution, and other disclosures required for transparency and accountability in postsecondary education.',
                  path: 'http://oira.ua.edu/HEA/',
                  type: 'HTML',
                  external: true,
                },
                {
                  title: 'New Students by Legal Residency',
                  description: 'Legal residency of Fall new entering students.',
                  path: 'https://oira.ua.edu/factbooklegacy/reports/admissions-and-new-students/new-students/new-students-by-legal-residency/',
                  type: 'HTML',
                  external: true,
                },
                {
                  title: 'Instructional Facilities',
                  description: 'Number of Rooms and Net Assignable Square Feet (NASF) by Primary Use Categories in Major Academic Buildings.',
                  path: 'https://oira.ua.edu/HEA/reports/general-information/facilities/',
                  type: 'HTML',
                  external: true,
                },
              ].map((card, index) => {
                const CardContent = (
                  <div className="card h-100 hover-shadow" style={{ cursor: 'pointer' }}>
                    <div className="card-body">
                      <h3 className="card-title red">{card.title}</h3>
                      <p className="card-text">{card.description}</p>
                    </div>
                    <div
                      style={{
                        height: '50px',
                        backgroundColor: '#990000',
                        width: '100%',
                        borderBottomLeftRadius: '4px',
                        borderBottomRightRadius: '4px',
                        display: 'flex',
                        alignItems: 'left',
                        justifyContent: 'left',
                        color: '#ffffff',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        paddingLeft: '20px',
                        paddingTop: '10px',
                      }}
                    >
                      {card.type}
                    </div>
                  </div>
                );

                return (
                  <div className="col-md-6 col-lg-6 mb-4" key={index}>
                    {card.external ? (
                      <a
                        href={card.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        {CardContent}
                      </a>
                    ) : (
                      <Link to={card.path} style={{ textDecoration: 'none', color: 'inherit' }}>
                        {CardContent}
                      </Link>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

const HoverLink = styled(Link)`
  display: inline-block;
  padding: 10px;
  background-color: #ffffff;
  color: #990000;
  text-decoration: none;
  border-radius: 5px;
  border: 2px solid #990000;
  text-align: center;
  font-family: Roboto, Verdana, Helvetica, sans-serif;
  transition: all 0.3s ease;

  &:hover {
    font-weight: bold;
    color: #ffffff;
    background-color: #990000;
  }
`;

export default IndexPage;
